export default function chartErrorsHandler($wrapper) {
    $wrapper.html('Произошла ошибка при построении графика');
}
